import { useState } from "react";
import axios from "axios";
import { ArrowRight, Check, Loader2 } from "lucide-react";
import { API } from "@/lib/feed";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      await axios.post(`${API}/subscribers`, { email });
      setStatus("done");
      setEmail("");
    } catch {
      setStatus("error");
    }
  };

  return (
    <section data-testid="newsletter-section" className="relative px-6 md:px-12 lg:px-20 pb-28">
      <div className="grid md:grid-cols-2 gap-10 border-t border-[var(--line)] pt-14">
        <div>
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-[var(--bone)]">02</span>
          <h2 className="font-display text-4xl md:text-5xl font-light leading-tight mt-6">
            The week in tech, <em className="italic text-[var(--ember)]">every Monday.</em>
          </h2>
          <p className="mt-5 text-[var(--ash)] max-w-md text-sm md:text-base">
            The week's most-talked-about HostNode stories, straight to your inbox. No spam, unsubscribe anytime.
          </p>
        </div>
        <div className="flex flex-col justify-end">
          {status === "done" ? (
            <p data-testid="newsletter-success" className="flex items-center gap-3 font-display text-2xl text-[var(--volt)]">
              <Check className="h-6 w-6" /> You're on the list.
            </p>
          ) : (
            <form onSubmit={submit} data-testid="newsletter-form" className="flex items-center border-b border-[var(--smoke)] focus-within:border-[var(--volt)] transition-colors duration-300">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@email.com"
                data-testid="newsletter-email-input"
                className="flex-1 bg-transparent py-4 text-lg md:text-xl outline-none placeholder:text-[var(--smoke)]"
              />
              <button type="submit" disabled={status === "loading"} data-testid="newsletter-submit-btn" aria-label="Subscribe" className="flex h-12 w-12 items-center justify-center rounded-full bg-[var(--volt)] text-[var(--ink)] transition-transform duration-300 hover:translate-x-1 disabled:opacity-60">
                {status === "loading" ? <Loader2 className="h-5 w-5 animate-spin" /> : <ArrowRight className="h-5 w-5" />}
              </button>
            </form>
          )}
          {status === "error" && (
            <p data-testid="newsletter-error" className="mt-3 text-sm text-[var(--ember)]">That email didn't work. Check it and try again.</p>
          )}
        </div>
      </div>
    </section>
  );
};
